// store/index.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import chatReducer from './chatSlice';
import questionsReducer from './questionSlice';

const rootReducer = combineReducers({
  chat: chatReducer,
  questions: questionsReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
